module.exports = __webpack_public_path__ + "img/frame (12).42911793.jpg";